<template>
  <div class="assessment-progress" aria-live="polite" aria-busy="true">
    <p>{{ $t('levelTest.processing') }}</p>
    <div class="progress-track" role="progressbar" :aria-label="$t('levelTest.processing')"><span /></div>
  </div>
</template>

<script>
export default { name: 'AssessmentProgress' }
</script>

<style scoped>
.assessment-progress { width: 100%; max-width: 280px; }
p { margin: 0 0 var(--space-4); color: var(--ink-secondary); font-size: var(--font-size-sm); }
.progress-track { height: 4px; overflow: hidden; border-radius: var(--radius-pill); background: var(--border-default); }
.progress-track span { display: block; width: 40%; height: 100%; border-radius: inherit; background: var(--signal-active-strong); animation: assessment-wait 1.6s ease-in-out infinite; }
@keyframes assessment-wait { from { transform: translateX(-100%); } to { transform: translateX(250%); } }
@media (prefers-reduced-motion: reduce) { .progress-track span { animation: none; width: 100%; opacity: 0.55; } }
</style>
